(() => {
  const KEY = "__MY_GALLERY_ARROWS_FINAL__";
  if (window[KEY]?.stop) window[KEY].stop();
// ===== DESKTOP ONLY (désactive tout sur mobile) =====
const MOBILE_MAX_W = 989; // ajuste si besoin (ex: 749 / 989 / 1024)
const MQ_MOBILE = window.matchMedia(`(max-width: ${MOBILE_MAX_W}px)`);

// si mobile -> on sort et on laisse le thème en natif
if (MQ_MOBILE.matches) {
  window[KEY] = { stop() {} }; // évite erreurs si tu rappelles le script
  return;
}

  // ================== SETTINGS ==================
  const OVERLAY_CLASS = "my-gallery-arrows";
  const INIT_ATTR = "data-my-arrows-init";
  const STYLE_ID = "my-arrows-and-antiflash-style";

  // Anti-flash / preload
  const PRELOAD_ALL_ON_INIT = true;   // true = charge toutes les images au chargement
  const PRELOAD_NEIGHBORS = true;     // true = précharge next/prev à chaque changement de slide
  const SRCSET_TARGET_W = 1200;       // choisit une largeur dans srcset proche de 1200
  const MAX_WAIT_MS = 2500;           // max attente decode avant de retirer le ghost
  const GHOST_FADE_MS = 120;          // fondu ghost
  const TRIGGER_COOLDOWN_MS = 260;    // évite double trigger (custom -> native)
  const DEBUG = false;
  // Slide-in anim
  const SLIDE_ANIM_MS = 500;
  const SLIDE_EASE = "cubic-bezier(.2,.8,.2,1)";
const FAST_NAV_ON_POINTERDOWN = true; // change l'image dès l'appui
const SKIP_CLICK_MS = 450;    
  const log = (...a) => DEBUG && console.log("[MG]", ...a);

  // ================== CSS ==================
  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    const st = document.createElement("style");
    st.id = STYLE_ID;
    st.textContent = `
      /* ===== Flèches overlay ===== */
    .${OVERLAY_CLASS}{ 
  position:absolute; inset:0;
  display:flex; align-items:center; justify-content:space-between;
  pointer-events:none;
  z-index: 10050; /* AU-DESSUS du ghost (9999) */
}
.mg-antiflash-ghost{
  border-radius: 14px !important;
}
.mg-antiflash-ghost > img{
  border-radius: 14px !important;
}



      .${OVERLAY_CLASS} .my-arrow{
        pointer-events:auto;
        width:44px; height:44px;
        border-radius:10px;
        border:0;
        cursor:pointer;
        display:flex; align-items:center; justify-content:center;
        margin:0 10px;
        background:rgba(0,0,0,.55);
        color:#fff;
        -webkit-tap-highlight-color: transparent;
      }
      .${OVERLAY_CLASS} .my-arrow svg{ width:26px; height:26px; }
      .${OVERLAY_CLASS} .my-arrow:active{ transform: scale(.98); }

      /* ===== Anti-flash ghost ===== */
      .mg-antiflash-ghost{
        position:absolute !important;
        z-index: 9999 !important;
        pointer-events:none !important;
        overflow:hidden !important;
        background: transparent !important;
        opacity: 1 !important;
        transition: opacity ${GHOST_FADE_MS}ms ease !important;
        transform: translateZ(0) !important;
        will-change: opacity, transform !important;
      }
      .mg-antiflash-ghost > img{
        position:absolute !important;
        inset:0 !important;
        width:100% !important;
        height:100% !important;
        max-width:100% !important;
        max-height:100% !important;
        display:block !important;
        object-fit: contain !important;   /* écrasé dynamiquement si besoin */
        object-position: center !important;
        transform: translateZ(0) !important;
      }
            /* ===== Slide-in anim (sur la nouvelle image) ===== */
      @keyframes mgInFromRight {
        from { transform: translateX(16px); opacity: .85; }
        to   { transform: translateX(0);    opacity: 1; }
      }
      @keyframes mgInFromLeft {
        from { transform: translateX(-16px); opacity: .85; }
        to   { transform: translateX(0);     opacity: 1; }
      }

     .mg-slide-in-next { animation: mgInFromRight ${SLIDE_ANIM_MS}ms ${SLIDE_EASE} both !important; will-change: transform, opacity; }
.mg-slide-in-prev { animation: mgInFromLeft  ${SLIDE_ANIM_MS}ms ${SLIDE_EASE} both !important; will-change: transform, opacity; }

    `;
    document.head.appendChild(st);
  }

  // ================== Overlay DOM ==================
  function createOverlay() {
    const wrap = document.createElement("div");
    wrap.className = OVERLAY_CLASS;
    wrap.innerHTML = `
      <button type="button" class="my-arrow my-prev" aria-label="Image précédente">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        </svg>
      </button>
      <button type="button" class="my-arrow my-next" aria-label="Image suivante">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="m8.59 16.59 1.41 1.41 6-6-6-6-1.41 1.41L13.17 12z"/>
        </svg>
      </button>
    `;
    return wrap;
  }

  // ================== Utilitaires ==================
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  // mémorise la direction par galerie
  const LAST_DIR = new WeakMap(); // gallery -> "next"|"prev"
  const setDir = (g, dir) => LAST_DIR.set(g, dir);
  const getDir = (g) => LAST_DIR.get(g) || "next";

 function applySlideAnim(gallery, dir) {
  const li = getActiveItem(gallery) || gallery.querySelector("li.is-active");
  if (!li) return;

  // ✅ cible stable et visible (évite les transforms du <img>)
  const target =
    li.querySelector(".product__modal-opener.product__modal-opener--image") ||
    li.querySelector(".product__media") ||
    li;

  target.classList.remove("mg-slide-in-next", "mg-slide-in-prev");
  void target.offsetWidth; // reflow pour rejouer l'anim

  target.classList.add(dir === "prev" ? "mg-slide-in-prev" : "mg-slide-in-next");

  clearTimeout(target.__mgAnimT);
  target.__mgAnimT = setTimeout(() => {
    target.classList.remove("mg-slide-in-next", "mg-slide-in-prev");
  }, SLIDE_ANIM_MS + 80);
}


  function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  function firePointerTap(el) {
    if (!el) return false;
    const opts = { bubbles: true, cancelable: true, composed: true, pointerId: 1, pointerType: "mouse", isPrimary: true };
    try {
      el.dispatchEvent(new PointerEvent("pointerdown", opts));
      el.dispatchEvent(new PointerEvent("pointerup", opts));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      return true;
    } catch {
      el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent("mouseup", { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      return true;
    }
  }

  function getList(gallery) {
    return (
      gallery.querySelector(".product__media-list") ||
      gallery.querySelector("ul[id^='Slider-Gallery']") ||
      null
    );
  }

  function getItems(gallery) {
    const list = getList(gallery);
    if (!list) return [];
    return [...list.querySelectorAll("li.product__media-item, li")];
  }

  function getActiveItem(gallery) {
    return (
      gallery.querySelector("li.product__media-item.is-active") ||
      gallery.querySelector("li.is-active") ||
      null
    );
  }

  function getThumbs(gallery) {
    const nodes = [
      ...gallery.querySelectorAll(
        ".thumbnail-list__item button.thumbnail, .thumbnail-list__item .thumbnail, button.thumbnail, [data-target*='MediaGallery'], [aria-controls*='Gallery']"
      ),
    ];
    return nodes.map((x) => x.closest("button") || x).filter(Boolean);
  }

  function activeIndex(gallery) {
    const items = getItems(gallery);
    const a = getActiveItem(gallery);
    if (a && items.length) {
      const idx = items.indexOf(a);
      if (idx >= 0) return idx;
    }
    const t = getThumbs(gallery);
    const idx2 = t.findIndex((b) => b.getAttribute("aria-current") === "true");
    return idx2 >= 0 ? idx2 : 0;
  }

  function mediaIdOf(li) {
    if (!li) return null;
    return (
      li.dataset?.mediaId ||
      li.getAttribute("data-media-id") ||
      li.id ||
      li.querySelector("[data-media-id]")?.getAttribute("data-media-id") ||
      null
    );
  }

  // ================== Navigation (stable) ==================
  async function tryNativeButtons(gallery, dir) {
    const sel = dir === "next"
      ? "button.slider-button--next, .slider-button--next"
      : "button.slider-button--prev, .slider-button--prev";

    const btns = [...gallery.querySelectorAll(sel)]
      .filter((b) => !b.hasAttribute("disabled") && b.getAttribute("aria-disabled") !== "true");

    if (!btns.length) return false;

    const before = activeIndex(gallery);
    for (const b of btns) {
      b.click?.();
      await wait(120);
      if (activeIndex(gallery) !== before) return true;

      firePointerTap(b);
      await wait(120);
      if (activeIndex(gallery) !== before) return true;
    }
    return false;
  }

  async function trySetActiveMedia(gallery, dir) {
    if (typeof gallery.setActiveMedia !== "function") return false;

    const items = getItems(gallery);
    if (!items.length) return false;

    const before = activeIndex(gallery);
    const total = items.length;
    const nextIdx = dir === "next" ? (before + 1) % total : (before - 1 + total) % total;
    const targetLi = items[nextIdx];
    const mediaId = mediaIdOf(targetLi);
    if (!mediaId) return false;

    try {
      gallery.setActiveMedia(mediaId);
      await wait(120);
      if (activeIndex(gallery) !== before) return true;

      gallery.setActiveMedia(mediaId, true);
      await wait(120);
      if (activeIndex(gallery) !== before) return true;
    } catch {}
    return false;
  }

  async function tryThumbs(gallery, dir) {
    const t = getThumbs(gallery);
    if (!t.length) return false;

    const before = activeIndex(gallery);
    const total = t.length;
    const nextIdx = dir === "next" ? (before + 1) % total : (before - 1 + total) % total;
    const btn = t[nextIdx];
    if (!btn) return false;

    btn.click?.();
    await wait(120);
    if (activeIndex(gallery) !== before) return true;

    firePointerTap(btn);
    await wait(120);
    if (activeIndex(gallery) !== before) return true;

    return false;
  }

  async function tryScroll(gallery, dir) {
    const list = getList(gallery);
    if (!list) return false;

    const before = activeIndex(gallery);
    const dx = Math.max(80, list.clientWidth || 0);
    const delta = dir === "next" ? dx : -dx;

    try {
      list.scrollBy({ left: delta, behavior: "auto" });
      await wait(120);
      if (activeIndex(gallery) !== before) return true;

      list.scrollLeft = list.scrollLeft + delta;
      await wait(120);
      if (activeIndex(gallery) !== before) return true;
    } catch {}
    return false;
  }

  async function tryKeyboard(gallery, dir) {
    const before = activeIndex(gallery);
    const key = dir === "next" ? "ArrowRight" : "ArrowLeft";
    const list = getList(gallery);
    const target = getActiveItem(gallery) || list || gallery;
    target?.focus?.();

    document.dispatchEvent(new KeyboardEvent("keydown", { key, bubbles: true, cancelable: true }));
    await wait(120);
    return activeIndex(gallery) !== before;
  }

  async function navigate(gallery, dir) {
    if (await tryNativeButtons(gallery, dir)) return;
    if (await trySetActiveMedia(gallery, dir)) return;
    if (await tryThumbs(gallery, dir)) return;
    if (await tryScroll(gallery, dir)) return;
    await tryKeyboard(gallery, dir);
  }

  // ================== Overlay placement ==================
  function attachOverlayToActiveOpener(gallery, overlay) {
    const activeSlide =
      gallery.querySelector("li.product__media-item.is-active") ||
      gallery.querySelector("li.product__media-item") ||
      gallery;

    if (!activeSlide) return;

    const opener =
      activeSlide.querySelector(".product__modal-opener.product__modal-opener--image") ||
      activeSlide;

    if (overlay.parentElement !== opener) opener.appendChild(overlay);
  }

  // ================== Anti-flash core ==================
  const AF = (() => {
    const GHOST_CLASS = "mg-antiflash-ghost";
    const preloadCache = new Set();
    const perGallery = new WeakMap();

    const getViewport = (g) => {
      const list = getList(g);
      if (!list) return null;
      return list.closest("slider-component") || list.closest(".slider") || list.parentElement || list;
    };

    const slides = (g) => {
      const list = getList(g);
      if (!list) return [];
      return Array.from(list.querySelectorAll(":scope > li"));
    };

    const activeSlide = (g) => slides(g).find(li => li.classList.contains("is-active")) || slides(g)[0] || null;

    const imgOfSlide = (li) =>
      li?.querySelector(".product__media img") ||
      li?.querySelector("picture img") ||
      li?.querySelector("img") ||
      null;

    const mediaBoxOfSlide = (li) =>
      li?.querySelector(".product__media") ||
      li?.querySelector(".media") ||
      li ||
      null;

    function parseSrcsetPick(srcset, targetW = SRCSET_TARGET_W) {
      if (!srcset) return null;
      const parts = srcset.split(",").map(x => x.trim()).filter(Boolean);
      const cands = [];
      for (const p of parts) {
        const m = p.match(/^(.*)\s+(\d+)w$/);
        if (m) cands.push({ url: m[1].trim(), w: parseInt(m[2], 10) });
        else cands.push({ url: p.split(/\s+/)[0], w: Number.POSITIVE_INFINITY });
      }
      cands.sort((a,b) => a.w - b.w);
      const best = cands.filter(c => Number.isFinite(c.w) && c.w <= targetW).pop() || cands[0];
      return best?.url || null;
    }

    function pickImgUrl(img) {
      if (!img) return null;
      if (img.currentSrc) return img.currentSrc;
      const ss = img.getAttribute("srcset");
      const fromSS = parseSrcsetPick(ss, SRCSET_TARGET_W);
      if (fromSS) return fromSS;
      return img.getAttribute("src") || img.src || null;
    }

    function preloadUrl(url) {
      if (!url || preloadCache.has(url)) return;
      preloadCache.add(url);
      const im = new Image();
      im.decoding = "async";
      im.src = url;
      im.decode?.().catch(() => {});
    }

    function preloadAll(g) {
      for (const li of slides(g)) preloadUrl(pickImgUrl(imgOfSlide(li)));
      log("AF preloadAll");
    }

    function preloadNeighbors(g) {
      const s = slides(g);
      if (!s.length) return;
      const a = activeSlide(g);
      const idx = s.indexOf(a);
      if (idx < 0) return;
      const next = s[(idx + 1) % s.length];
      const prev = s[(idx - 1 + s.length) % s.length];
      preloadUrl(pickImgUrl(imgOfSlide(next)));
      preloadUrl(pickImgUrl(imgOfSlide(prev)));
      log("AF preloadNeighbors", idx);
    }

    function getState(g) {
      if (!perGallery.has(g)) perGallery.set(g, { lastTrigger: 0, token: 0, mo: null });
      return perGallery.get(g);
    }

    function ensureGhost(g) {
      const vp = getViewport(g);
      if (!vp) return null;

      // viewport doit clipper
      vp.style.position = "relative";
      vp.style.overflow = "hidden";

      let ghost = vp.querySelector(`.${GHOST_CLASS}`);
      if (!ghost) {
        ghost = document.createElement("div");
        ghost.className = GHOST_CLASS;
        const im = document.createElement("img");
        ghost.appendChild(im);
        vp.appendChild(ghost);
      }
      return ghost;
    }

    function showGhost(g) {
      const vp = getViewport(g);
      const li = activeSlide(g);
      if (!vp || !li) return;

      const box = mediaBoxOfSlide(li);
      const img = imgOfSlide(li);
      const url = pickImgUrl(img);
      if (!box || !url) return;

      const ghost = ensureGhost(g);
      if (!ghost) return;

      const vpRect = vp.getBoundingClientRect();
      const boxRect = box.getBoundingClientRect();

      // ✅ clé du fix: ghost = EXACTEMENT la box .product__media
      ghost.style.left = (boxRect.left - vpRect.left) + "px";
      ghost.style.top = (boxRect.top - vpRect.top) + "px";
      ghost.style.width = boxRect.width + "px";
      ghost.style.height = boxRect.height + "px";
      ghost.style.display = "block";
      ghost.style.opacity = "1";

      const ghostImg = ghost.querySelector("img");
   


      ghostImg.src = url;

      // copie object-fit / object-position si thème les change
      try {
        const cs = img ? getComputedStyle(img) : null;
        if (cs?.objectFit) ghostImg.style.objectFit = cs.objectFit;
        if (cs?.objectPosition) ghostImg.style.objectPosition = cs.objectPosition;
      } catch {}
      

      log("AF ghost show", url);
    }

   function hideGhost(g) {
  const vp = getViewport(g);
  const ghost = vp?.querySelector?.(`.${GHOST_CLASS}`);
  if (!ghost) return;

  // ✅ on coupe direct, sinon il masque l'anim de slide-in
  ghost.style.transition = "none";
  ghost.style.opacity = "0";
  ghost.style.display = "none";
  void ghost.offsetWidth; // restore pour la prochaine fois
  ghost.style.transition = `opacity ${GHOST_FADE_MS}ms ease`;
}

    function nextPaint() {
      return new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
    }

    async function waitForImgReady(img, timeoutMs = MAX_WAIT_MS) {
      if (!img) return false;
      const start = performance.now();
      const ok = () => img.complete && img.naturalWidth > 0;

      if (ok()) {
        try { await (img.decode?.() ?? Promise.resolve()); } catch {}
        return true;
      }

      return await new Promise((resolve) => {
        let done = false;
        const cleanup = () => {
          if (done) return;
          done = true;
          img.removeEventListener("load", onLoad, true);
          img.removeEventListener("error", onErr, true);
        };
        const onLoad = async () => {
          cleanup();
          try { await (img.decode?.() ?? Promise.resolve()); } catch {}
          resolve(true);
        };
        const onErr = () => { cleanup(); resolve(false); };

        img.addEventListener("load", onLoad, true);
        img.addEventListener("error", onErr, true);

        const tick = () => {
          if (done) return;
          if (ok()) { onLoad(); return; }
          if (performance.now() - start > timeoutMs) { cleanup(); resolve(false); return; }
          requestAnimationFrame(tick);
        };
        tick();
      });
    }

    async function onActiveChanged(g, expectedToken) {
      const s = getState(g);
      if (expectedToken !== s.token) return;

      const li = activeSlide(g);
      const img = imgOfSlide(li);

      await waitForImgReady(img, MAX_WAIT_MS);
      await nextPaint();

      if (expectedToken !== s.token) return;
hideGhost(g);
requestAnimationFrame(() => applySlideAnim(g, getDir(g)));
if (PRELOAD_NEIGHBORS) preloadNeighbors(g);

    }

    function observe(g) {
      const list = getList(g);
      if (!list) return;

      const s = getState(g);
      if (s.mo) return;

      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.type === "attributes" && m.attributeName === "class") {
            const tgt = m.target;
            if (tgt?.tagName === "LI" && tgt.classList.contains("is-active")) {
              onActiveChanged(g, getState(g).token);
              break;
            }
          }
        }
      });

      slides(g).forEach(li => mo.observe(li, { attributes: true, attributeFilter: ["class"] }));

      // rebind si rerender
      const moRebind = new MutationObserver(() => {
        mo.disconnect();
        slides(g).forEach(li => mo.observe(li, { attributes: true, attributeFilter: ["class"] }));
      });
      moRebind.observe(list, { childList: true, subtree: false });

      s.mo = { mo, moRebind };
    }

    function trigger(g) {
      if (!g) return;
      const s = getState(g);
      const now = performance.now();
      if (now - s.lastTrigger < TRIGGER_COOLDOWN_MS) return;
      s.lastTrigger = now;

      s.token += 1;
      showGhost(g);
      if (PRELOAD_NEIGHBORS) preloadNeighbors(g);
    }

    function init(g) {
      observe(g);
      if (PRELOAD_ALL_ON_INIT) preloadAll(g);
      else if (PRELOAD_NEIGHBORS) preloadNeighbors(g);
    }

    function cleanupAll() {
      document.querySelectorAll("media-gallery").forEach(g => {
        const s = perGallery.get(g);
        s?.mo?.mo?.disconnect?.();
        s?.mo?.moRebind?.disconnect?.();
      });
      document.querySelectorAll(".mg-antiflash-ghost").forEach(n => n.remove());
    }

    return { trigger, init, cleanupAll };
  })();

  // ================== Init gallery ==================
  const overlays = new WeakMap();

  function initOneGallery(gallery) {
    if (!gallery || gallery.getAttribute(INIT_ATTR) === "1") return;
    gallery.setAttribute(INIT_ATTR, "1");

    injectCSS();
    AF.init(gallery);

    const overlay = createOverlay();
    overlays.set(gallery, overlay);

    const prev = overlay.querySelector(".my-prev");
    const next = overlay.querySelector(".my-next");

 ["pointerdown", "mousedown", "touchstart"].forEach((evt) => {
  prev.addEventListener(evt, (e) => {
    stopEvent(e);
    setDir(gallery, "prev");
    AF.trigger(gallery);

    if (FAST_NAV_ON_POINTERDOWN) {
      gallery.__mgSkipClickUntil = performance.now() + SKIP_CLICK_MS;
      navigate(gallery, "prev"); // 🔥 démarre tout de suite
    }
  }, { capture: true, passive: false });

  next.addEventListener(evt, (e) => {
    stopEvent(e);
    setDir(gallery, "next");
    AF.trigger(gallery);

    if (FAST_NAV_ON_POINTERDOWN) {
      gallery.__mgSkipClickUntil = performance.now() + SKIP_CLICK_MS;
      navigate(gallery, "next"); // 🔥 démarre tout de suite
    }
  }, { capture: true, passive: false });
});

    // click => navigate
prev.addEventListener("click", (e) => {
  stopEvent(e);
  if (gallery.__mgSkipClickUntil && performance.now() < gallery.__mgSkipClickUntil) return;

  setDir(gallery, "prev");
  navigate(gallery, "prev");
}, { capture: true, passive: false });

next.addEventListener("click", (e) => {
  stopEvent(e);
  if (gallery.__mgSkipClickUntil && performance.now() < gallery.__mgSkipClickUntil) return;

  setDir(gallery, "next");
  navigate(gallery, "next");
}, { capture: true, passive: false });


    // place overlay now + re-place when active slide changes
    const place = () => attachOverlayToActiveOpener(gallery, overlay);
    place();

    const mo = new MutationObserver(place);
    mo.observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-current", "style"],
    });

    // store observer for cleanup
    gallery.__myOverlayMO = mo;
  }

  let rafScheduled = false;
  function initAll() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(() => {
      rafScheduled = false;

      // remove duplicates overlays that got detached
      document.querySelectorAll("." + OVERLAY_CLASS).forEach((n) => {
        const host = n.closest("media-gallery");
        if (!host) n.remove();
      });

      document.querySelectorAll("media-gallery").forEach(initOneGallery);
    });
  }

  // Also trigger anti-flash when user clicks native next/prev (if visible)
  const nativeHook = (e) => {
    const btn = e.target.closest?.(".slider-button--next, .slider-button--prev");
    if (!btn) return;
    const g = btn.closest("media-gallery") || document.querySelector("media-gallery");
    const dir = btn.classList.contains("slider-button--prev") ? "prev" : "next";
    setDir(g, dir);
    AF.trigger(g);
  };


  // ================== Boot ==================
  initAll();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  }

  const globalObserver = new MutationObserver(initAll);
  globalObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);

  document.addEventListener("pointerdown", nativeHook, true);
  document.addEventListener("mousedown", nativeHook, true);
  document.addEventListener("touchstart", nativeHook, { capture: true, passive: true });

  // ================== Public stop ==================
  window[KEY] = {
    stop() {
      globalObserver.disconnect();
      document.removeEventListener("DOMContentLoaded", initAll);
      document.removeEventListener("shopify:section:load", initAll);
      document.removeEventListener("shopify:section:reorder", initAll);

      document.removeEventListener("pointerdown", nativeHook, true);
      document.removeEventListener("mousedown", nativeHook, true);
      document.removeEventListener("touchstart", nativeHook, true);

      document.querySelectorAll("media-gallery").forEach((g) => {
        if (g.__myOverlayMO) g.__myOverlayMO.disconnect();
        g.removeAttribute(INIT_ATTR);
      });

      AF.cleanupAll();
      document.getElementById(STYLE_ID)?.remove?.();
      document.querySelectorAll("." + OVERLAY_CLASS).forEach(n => n.remove());
      log("stopped");
    }
  };
})();
